import { render } from "./uploader.vue.erb?vue&type=template&id=5539ac2f"
import script from "./uploader.vue.erb?vue&type=script&lang=js"
export * from "./uploader.vue.erb?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
var __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__